import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=78a6abf4&scoped=true&"
import script from "./MainForm.vue?vue&type=script&lang=js&"
export * from "./MainForm.vue?vue&type=script&lang=js&"
import style0 from "./MainForm.vue?vue&type=style&index=0&id=78a6abf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6abf4",
  null
  
)

export default component.exports